import { tns } from 'tiny-slider/src/tiny-slider';

class BlockAccordion {
	constructor(el) {
		this.accordion = el;
        this.accSections = this.accordion.querySelectorAll('.block-accordion__acc-section');
        this.accHeaders = this.accordion.querySelectorAll('.block-accordion__acc-header');
        this.accContent = this.accordion.querySelectorAll('.block-accordion__acc-content');
        this.accImages = this.accordion.querySelectorAll('.block-accordion__acc-image');
        
        this.setEventHandlers(this.accHeaders);
    }

    setEventHandlers() {
        this.accHeaders.forEach(accHeader => {
            accHeader.addEventListener('click', () => {
                
                // Accordion Content
                const acc = this.accordion.querySelector(`[data-acc="${accHeader.getAttribute('data-heading')}"]`);

                if (acc.classList.contains('active')) {
                    acc.classList.toggle('active');   
                } else {
                    this.accSections.forEach(accSection => {
                        accSection.classList.remove('active');
                    });
                    acc.classList.add('active');
                }

                // Accordion Images
                const img = this.accordion.querySelector(`[data-image="${accHeader.getAttribute('data-heading')}"]`);

                if(img.classList.contains('active')) {
                    acc.classList.toggle('active');  
                } else {
                    this.accImages.forEach(accImage => {
                        accImage.classList.remove('active');
                    });
                    img.classList.add('active');
                }
            });
        });
    }
}

export default BlockAccordion;